<template>
  <div style="text-align:center;" class="table8">
    <table border="1" style="border-bottom:0">
      <!-- 第1行(1表) -->
      <tr style="height:100px">
        <td width="25%" class="titleSpan companyTitle KaiTi">河南邦泰合力管理咨询有限公司</td>
        <td width="50%" class="titleSpan tableTitle">项 目 内 部 审 核 表</td>
        <td style="border:0" class="titleSpan">BTHL-GK-001</td>
      </tr>
    </table>
    <table border="1">
      <!-- 第2行(2表) -->
      <tr style="height:50px">
        <td width="10%" class="titleSpan">项目名称</td>
        <td class="contentSpan">{{printData.company_name}}</td>
      </tr>
      <!-- 第3行(2表) -->
      <tr style="height:50px">
        <td width="10%" class="titleSpan">内部审核人员</td>
        <td class="contentSpan">{{printData.company_name}}</td>
      </tr>
    </table>
    <table border="1" style="border-top:0">
      <tr style="height:50px">
        <td class="titleSpan" colspan="2">项 目 审 核 内 容</td>
      </tr>
      <!-- 第16行(4表) -->
      <tr style="height:200px">
        <td style="width:50%">
          <div class="riskBox">
            <!-- 左1 -->
            <div class="riskItem" style="justify-content:space-between;padding-right:10px">
              <div>1.报告封面、著录项是否符合导则要求：</div>
              <div style="display:flex">
                <div class="yesOrNoItem">
                  <div>是</div>
                  <div style="padding-top:2px;">
                    <img
                      style="width:15px"
                      v-if="printData.analysis_1st==1"
                      src="../../assets/image/tableSelected_selected.png"
                      alt
                    />
                    <img
                      style="width:15px"
                      v-else
                      src="../../assets/image/tableSelected_unselected.png"
                      alt
                    />
                  </div>
                </div>
                <div class="yesOrNoItem" style="margin-left:10px">
                  <div>否</div>
                  <div style="padding-top:2px;">
                    <img
                      style="width:15px"
                      v-if="printData.analysis_1st!=1"
                      src="../../assets/image/tableSelected_selected.png"
                      alt
                    />
                    <img
                      style="width:15px"
                      v-else
                      src="../../assets/image/tableSelected_unselected.png"
                      alt
                    />
                  </div>
                </div>
              </div>
            </div>
            <!-- 左2 -->
            <div class="riskItem" style="justify-content:space-between;padding-right:10px">
              <div>2.评价依据是否充分有效：</div>
              <div style="display:flex">
                <div class="yesOrNoItem">
                  <div>是</div>
                  <div style="padding-top:2px;">
                    <img
                      style="width:15px"
                      v-if="printData.analysis_1st==1"
                      src="../../assets/image/tableSelected_selected.png"
                      alt
                    />
                    <img
                      style="width:15px"
                      v-else
                      src="../../assets/image/tableSelected_unselected.png"
                      alt
                    />
                  </div>
                </div>
                <div class="yesOrNoItem" style="margin-left:10px">
                  <div>否</div>
                  <div style="padding-top:2px;">
                    <img
                      style="width:15px"
                      v-if="printData.analysis_1st!=1"
                      src="../../assets/image/tableSelected_selected.png"
                      alt
                    />
                    <img
                      style="width:15px"
                      v-else
                      src="../../assets/image/tableSelected_unselected.png"
                      alt
                    />
                  </div>
                </div>
              </div>
            </div>
            <!-- 左3 -->
            <div class="riskItem" style="justify-content:space-between;padding-right:10px">
              <div>3.是否存在引用过期失效的规范标准：</div>
              <div style="display:flex">
                <div class="yesOrNoItem">
                  <div>是</div>
                  <div style="padding-top:2px;">
                    <img
                      style="width:15px"
                      v-if="printData.analysis_1st==1"
                      src="../../assets/image/tableSelected_selected.png"
                      alt
                    />
                    <img
                      style="width:15px"
                      v-else
                      src="../../assets/image/tableSelected_unselected.png"
                      alt
                    />
                  </div>
                </div>
                <div class="yesOrNoItem" style="margin-left:10px">
                  <div>否</div>
                  <div style="padding-top:2px;">
                    <img
                      style="width:15px"
                      v-if="printData.analysis_1st!=1"
                      src="../../assets/image/tableSelected_selected.png"
                      alt
                    />
                    <img
                      style="width:15px"
                      v-else
                      src="../../assets/image/tableSelected_unselected.png"
                      alt
                    />
                  </div>
                </div>
              </div>
            </div>
            <!-- 左4 -->
            <div class="riskItem" style="justify-content:space-between;padding-right:10px">
              <div>4.危险有害因素识别是否全面：</div>
              <div style="display:flex">
                <div class="yesOrNoItem">
                  <div>是</div>
                  <div style="padding-top:2px;">
                    <img
                      style="width:15px"
                      v-if="printData.analysis_1st==1"
                      src="../../assets/image/tableSelected_selected.png"
                      alt
                    />
                    <img
                      style="width:15px"
                      v-else
                      src="../../assets/image/tableSelected_unselected.png"
                      alt
                    />
                  </div>
                </div>
                <div class="yesOrNoItem" style="margin-left:10px">
                  <div>否</div>
                  <div style="padding-top:2px;">
                    <img
                      style="width:15px"
                      v-if="printData.analysis_1st!=1"
                      src="../../assets/image/tableSelected_selected.png"
                      alt
                    />
                    <img
                      style="width:15px"
                      v-else
                      src="../../assets/image/tableSelected_unselected.png"
                      alt
                    />
                  </div>
                </div>
              </div>
            </div>
            <!-- 左5 -->
            <div class="riskItem" style="justify-content:space-between;padding-right:10px">
              <div>5.评价单元划分是否合理：</div>
              <div style="display:flex">
                <div class="yesOrNoItem">
                  <div>是</div>
                  <div style="padding-top:2px;">
                    <img
                      style="width:15px"
                      v-if="printData.analysis_1st==1"
                      src="../../assets/image/tableSelected_selected.png"
                      alt
                    />
                    <img
                      style="width:15px"
                      v-else
                      src="../../assets/image/tableSelected_unselected.png"
                      alt
                    />
                  </div>
                </div>
                <div class="yesOrNoItem" style="margin-left:10px">
                  <div>否</div>
                  <div style="padding-top:2px;">
                    <img
                      style="width:15px"
                      v-if="printData.analysis_1st!=1"
                      src="../../assets/image/tableSelected_selected.png"
                      alt
                    />
                    <img
                      style="width:15px"
                      v-else
                      src="../../assets/image/tableSelected_unselected.png"
                      alt
                    />
                  </div>
                </div>
              </div>
            </div>
            <!-- 左6 -->
            <div class="riskItem" style="justify-content:space-between;padding-right:10px">
              <div>6.评价方法选择是否适当：</div>
              <div style="display:flex">
                <div class="yesOrNoItem">
                  <div>是</div>
                  <div style="padding-top:2px;">
                    <img
                      style="width:15px"
                      v-if="printData.analysis_1st==1"
                      src="../../assets/image/tableSelected_selected.png"
                      alt
                    />
                    <img
                      style="width:15px"
                      v-else
                      src="../../assets/image/tableSelected_unselected.png"
                      alt
                    />
                  </div>
                </div>
                <div class="yesOrNoItem" style="margin-left:10px">
                  <div>否</div>
                  <div style="padding-top:2px;">
                    <img
                      style="width:15px"
                      v-if="printData.analysis_1st!=1"
                      src="../../assets/image/tableSelected_selected.png"
                      alt
                    />
                    <img
                      style="width:15px"
                      v-else
                      src="../../assets/image/tableSelected_unselected.png"
                      alt
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </td>
        <td>
          <div class="riskBox">
            <!-- 右7 -->
            <div class="riskItem" style="justify-content:space-between;padding-right:10px">
              <div>7.对策措施是否可行：</div>
              <div style="display:flex">
                <div class="yesOrNoItem">
                  <div>是</div>
                  <div style="padding-top:2px;">
                    <img
                      style="width:15px"
                      v-if="printData.analysis_1st==1"
                      src="../../assets/image/tableSelected_selected.png"
                      alt
                    />
                    <img
                      style="width:15px"
                      v-else
                      src="../../assets/image/tableSelected_unselected.png"
                      alt
                    />
                  </div>
                </div>
                <div class="yesOrNoItem" style="margin-left:10px">
                  <div>否</div>
                  <div style="padding-top:2px;">
                    <img
                      style="width:15px"
                      v-if="printData.analysis_1st!=1"
                      src="../../assets/image/tableSelected_selected.png"
                      alt
                    />
                    <img
                      style="width:15px"
                      v-else
                      src="../../assets/image/tableSelected_unselected.png"
                      alt
                    />
                  </div>
                </div>
              </div>
            </div>
            <!-- 右8 -->
            <div class="riskItem" style="justify-content:space-between;padding-right:10px">
              <div>8.结论是否正确：</div>
              <div style="display:flex">
                <div class="yesOrNoItem">
                  <div>是</div>
                  <div style="padding-top:2px;">
                    <img
                      style="width:15px"
                      v-if="printData.analysis_1st==1"
                      src="../../assets/image/tableSelected_selected.png"
                      alt
                    />
                    <img
                      style="width:15px"
                      v-else
                      src="../../assets/image/tableSelected_unselected.png"
                      alt
                    />
                  </div>
                </div>
                <div class="yesOrNoItem" style="margin-left:10px">
                  <div>否</div>
                  <div style="padding-top:2px;">
                    <img
                      style="width:15px"
                      v-if="printData.analysis_1st!=1"
                      src="../../assets/image/tableSelected_selected.png"
                      alt
                    />
                    <img
                      style="width:15px"
                      v-else
                      src="../../assets/image/tableSelected_unselected.png"
                      alt
                    />
                  </div>
                </div>
              </div>
            </div>
            <!-- 右9 -->
            <div class="riskItem" style="justify-content:space-between;padding-right:10px">
              <div>9.格式是否符合要求：</div>
              <div style="display:flex">
                <div class="yesOrNoItem">
                  <div>是</div>
                  <div style="padding-top:2px;">
                    <img
                      style="width:15px"
                      v-if="printData.analysis_1st==1"
                      src="../../assets/image/tableSelected_selected.png"
                      alt
                    />
                    <img
                      style="width:15px"
                      v-else
                      src="../../assets/image/tableSelected_unselected.png"
                      alt
                    />
                  </div>
                </div>
                <div class="yesOrNoItem" style="margin-left:10px">
                  <div>否</div>
                  <div style="padding-top:2px;">
                    <img
                      style="width:15px"
                      v-if="printData.analysis_1st!=1"
                      src="../../assets/image/tableSelected_selected.png"
                      alt
                    />
                    <img
                      style="width:15px"
                      v-else
                      src="../../assets/image/tableSelected_unselected.png"
                      alt
                    />
                  </div>
                </div>
              </div>
            </div>
            <!-- 右10 -->
            <div class="riskItem" style="justify-content:space-between;padding-right:10px">
              <div>10.文字是否在公司控制指标内：</div>
              <div style="display:flex">
                <div class="yesOrNoItem">
                  <div>是</div>
                  <div style="padding-top:2px;">
                    <img
                      style="width:15px"
                      v-if="printData.analysis_1st==1"
                      src="../../assets/image/tableSelected_selected.png"
                      alt
                    />
                    <img
                      style="width:15px"
                      v-else
                      src="../../assets/image/tableSelected_unselected.png"
                      alt
                    />
                  </div>
                </div>
                <div class="yesOrNoItem" style="margin-left:10px">
                  <div>否</div>
                  <div style="padding-top:2px;">
                    <img
                      style="width:15px"
                      v-if="printData.analysis_1st!=1"
                      src="../../assets/image/tableSelected_selected.png"
                      alt
                    />
                    <img
                      style="width:15px"
                      v-else
                      src="../../assets/image/tableSelected_unselected.png"
                      alt
                    />
                  </div>
                </div>
              </div>
            </div>
            <!-- 右11 -->
            <div class="riskItem" style="justify-content:space-between;padding-right:10px">
              <div>11.技术文件附录、附件、附图是否齐全规范：</div>
              <div style="display:flex">
                <div class="yesOrNoItem">
                  <div>是</div>
                  <div style="padding-top:2px;">
                    <img
                      style="width:15px"
                      v-if="printData.analysis_1st==1"
                      src="../../assets/image/tableSelected_selected.png"
                      alt
                    />
                    <img
                      style="width:15px"
                      v-else
                      src="../../assets/image/tableSelected_unselected.png"
                      alt
                    />
                  </div>
                </div>
                <div class="yesOrNoItem" style="margin-left:10px">
                  <div>否</div>
                  <div style="padding-top:2px;">
                    <img
                      style="width:15px"
                      v-if="printData.analysis_1st!=1"
                      src="../../assets/image/tableSelected_selected.png"
                      alt
                    />
                    <img
                      style="width:15px"
                      v-else
                      src="../../assets/image/tableSelected_unselected.png"
                      alt
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </td>
      </tr>
    </table>
    <table border="1" style="border-top:0">
      <tr style="height:100px">
        <td class="titleSpan" style="width:10%">审核意见</td>
        <td style="height: 100px;">
          <div class="riskBox2">
            <div style="text-align:left;padding:10px;">{{`12312313123123`}}</div>
            <div
              style="min-height:100px;box-sizing:border-box;padding:10px; align-items:flex-end;"
              class="wirteTableRow"
            >
              <div class="pic" style="margin-left:400px;">
                <div>审核人签字:</div>
                <img src="../../assets/image/icon_MP4@2x.png" alt />
              </div>
              <div class="withWriteDateWithContent">年月日</div>
            </div>
          </div>
        </td>
      </tr>
      <tr style="height:100px">
        <td class="titleSpan" style="width:10%">修改情况</td>
        <td style="height: 100px;">
          <div class="riskBox2">
            <div style="text-align:left;padding:10px;">{{`12312313123123`}}</div>
            <div
              style="min-height:100px;box-sizing:border-box;padding:10px; align-items:flex-end;"
              class="wirteTableRow"
            >
              <div class="pic" style="margin-left:400px;">
                <div>项目负责人签字:</div>
                <img src="../../assets/image/icon_MP4@2x.png" alt />
              </div>
              <div class="withWriteDateWithContent">年月日</div>
            </div>
          </div>
        </td>
      </tr>
      <tr style="height:100px">
        <td class="titleSpan" style="width:10%">复审意见</td>
        <td style="height: 100px;">
          <div class="riskBox2">
            <div style="text-align:left;padding:10px;">{{`12312313123123`}}</div>
            <div
              style="min-height:100px;box-sizing:border-box;padding:10px; align-items:flex-end;"
              class="wirteTableRow"
            >
              <div class="pic" style="margin-left:400px;">
                <div>复审人签字:</div>
                <img src="../../assets/image/icon_MP4@2x.png" alt />
              </div>
              <div class="withWriteDateWithContent">年月日</div>
            </div>
          </div>
        </td>
      </tr>
    </table>
  </div>
</template>
<script>
import { mapState, mapGetters, mapMutations } from 'vuex'
export default {
  data() {
    return {
      // 评价类别
      pjTypeList: [
        {
          id: '1',
          label: '预评价',
        },
        {
          id: '2',
          label: '验收评价',
        },
        {
          id: '3',
          label: '现状评价',
        },
        {
          id: '4',
          label: '专项评价',
        },
        {
          id: '5',
          label: '其它',
        },
      ],
    }
  },
  computed: {
    ...mapState('process/projectTable', ['printData']),
  },
  methods: {},
  mounted() {},
  async created() {},
}
</script>
<style lang="less" scoped>
@import url(./printDialog.scss);
</style>